import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1040px]" }
const _hoisted_2 = { class: "flex items-center justify-between gap-6" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-6 border-t border-gray-100 pt-5"
}
const _hoisted_4 = { class: "grid gap-5 sm:grid-cols-2" }
const _hoisted_5 = { class: "divide-y divide-gray-100" }
const _hoisted_6 = {
  key: 0,
  class: "py-5 first:pt-0 last:pb-0"
}
const _hoisted_7 = {
  key: 1,
  class: "py-5 first:pt-0 last:pb-0"
}
const _hoisted_8 = {
  key: 2,
  class: "py-5 first:pt-0 last:pb-0"
}
const _hoisted_9 = { class: "mt-1 text-[13px] leading-relaxed text-gray-500" }
const _hoisted_10 = { key: 0 }

import { computed, inject, onMounted, reactive, ref } from 'vue'

import InputField from '@/components/neue/InputField'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import api from '@/store/api'
import { mapType } from '@/store/mappers'


export default {
  __name: 'StoreFees',
  props: ['id', 'only'],
  setup(__props) {

const bus = inject('bus')
const loading = ref(true)
const props = __props

// The page shows one of these two at a time, so it says which.
const shows = part => !props.only || props.only === part
const fees = computed(() => mapType('fee'))
const merchantFee = computed(() => fees.value.find(x => x.attributes.type === 'MerchantFee'))
const cardFee = computed(() => fees.value.find(x => x.attributes.type === 'ProcessingFee'))
const bottleNormalFee = computed(() => fees.value.find(x => x.attributes.type === 'BottleNormalProcessingFee'))
const bottleDropFee = computed(() => fees.value.find(x => x.attributes.type === 'BottleDropProcessingFee'))
const uberDirectFee = computed(() => fees.value.find(x => x.attributes.type === 'UberDirectFee'))
const uberSpreadPercent = computed(() => Math.round((uberDirectFee.value?.attributes.variable_rate || 0) * 1000) / 10)

const enable = ref(false)

const push = reactive({})

const merchant = reactive({
  flat: '',
  variable: '',
  name: ''
})

const load = () => {
  enable.value =
    merchantFee.value?.attributes.flat_rate_cents !== 0 || merchantFee.value?.attributes.variable_rate !== 0
  merchant.flat = (merchantFee.value?.attributes.flat_rate_cents / 100).toFixed(2)
  merchant.variable = merchantFee.value?.attributes.variable_rate * 100
  merchant.name = merchantFee.value?.attributes.custom_name

  if (cardFee.value) push.card = cardFee.value?.attributes.push_to_customer
  if (bottleNormalFee.value && bottleDropFee.value) push.bottle = bottleNormalFee.value?.attributes.push_to_customer
  if (uberDirectFee.value) push.uber = uberDirectFee.value?.attributes.push_to_customer
}

const setEnable = () => {
  if (!enable.value) {
    merchant.flat = 0
    merchant.variable = 0
    dirty()
  }
}

onMounted(async () => {
  await api.call('GET', 'fees')
  loading.value = false
  load()
})

const dirty = () => bus.emit('dirty/store', { from: 'fees' })

bus.on('save/store', () => {
  api.call('PUT', `fees/${merchantFee.value.id}`, {
    fee: {
      flat_rate_cents: merchant.flat * 100,
      variable_rate: merchant.variable / 100,
      custom_name: merchant.name
    }
  })
  if (cardFee.value) {
    api.call('PUT', `fees/${cardFee.value.id}`, {
      fee: {
        push_to_customer: push.card
      }
    })
  }
  if (bottleNormalFee.value && bottleDropFee.value) {
    api.call('PUT', `fees/${bottleNormalFee.value.id}`, {
      fee: {
        push_to_customer: push.bottle
      }
    })
    api.call('PUT', `fees/${bottleDropFee.value.id}`, {
      fee: {
        push_to_customer: push.bottle
      }
    })
  }
  if (uberDirectFee.value) {
    api.call('PUT', `fees/${uberDirectFee.value.id}`, { fee: { push_to_customer: push.uber } })
  }
})

bus.on('discard/store', load)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(NeueLoading), { loading: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (shows('merchant'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 0,
              title: "Your fee",
              description: "An extra fee charged at checkout. It is folded into the 'Taxes & Fees' line and goes straight to your bank account. This applies to every order across all of your stores, not just this one."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "min-w-0" }, [
                    _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Charge an additional fee"),
                    _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, "Off means customers pay no fee of yours.")
                  ], -1)),
                  _createVNode(_unref(NeueToggle), {
                    modelValue: enable.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((enable).value = $event)),
                    onChange: setEnable
                  }, null, 8, ["modelValue"])
                ]),
                (enable.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_unref(InputField), {
                        modelValue: merchant.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((merchant.name) = $event)),
                        name: "Fee name",
                        description: "What customers see it called. Blank means 'Service Fee'.",
                        onInput: dirty
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(InputField), {
                          modelValue: merchant.flat,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((merchant.flat) = $event)),
                          name: "Per-order fixed fee",
                          description: "Added to every order.",
                          prefix: "$",
                          onInput: dirty
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(InputField), {
                          modelValue: merchant.variable,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((merchant.variable) = $event)),
                          name: "Variable fee percentage",
                          description: "Calculated on each order's subtotal.",
                          suffix: "%",
                          onInput: dirty
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (shows('bottle'))
          ? (_openBlock(), _createBlock(SettingsSection, {
              key: 1,
              title: "Bottle fees",
              description: "Which of the fees on an order the customer covers, and which come out of your payout."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (cardFee.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-2" }, "Credit card processing fee", -1)),
                        _createVNode(_unref(NeueToggle), {
                          modelValue: push.card,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((push.card) = $event)),
                          name: "Push to customer",
                          onChange: dirty
                        }, null, 8, ["modelValue"]),
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-1 text-[13px] leading-relaxed text-gray-500" }, " Only charged to customers paying with a credit card. Card network rules do not allow this fee on debit or prepaid cards, so those orders are priced without it and you cover the processing fee. ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (bottleNormalFee.value && bottleDropFee.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-2" }, "Bottle service fee", -1)),
                        _createVNode(_unref(NeueToggle), {
                          modelValue: push.bottle,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((push.bottle) = $event)),
                          name: "Push to customer",
                          onChange: dirty
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (uberDirectFee.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-2" }, "Uber Direct delivery fee", -1)),
                        _createVNode(_unref(NeueToggle), {
                          modelValue: push.uber,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((push.uber) = $event)),
                          name: "Customer pays",
                          onChange: dirty
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("p", _hoisted_9, [
                          _cache[11] || (_cache[11] = _createTextVNode(" Uber quotes each courier trip at checkout. When on, the customer pays it as part of the normal delivery fee (Uber is never mentioned). When off, the courier fee is deducted from your payout. The fee is not refundable either way. ", -1)),
                          (uberSpreadPercent.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Includes a " + _toDisplayString(uberSpreadPercent.value) + "% platform spread.", 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

}